var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.635 6.0363L9.5049 5.59349L7.49996 0.865417L5.49502 5.60063L0.36496 6.0363L4.26067 9.41452L3.09053 14.4354L7.49996 11.7714L11.9094 14.4354L10.7464 9.41452L14.635 6.0363ZM7.49996 10.4358V3.79368L8.72005 6.67909L11.8452 6.95049L9.47636 9.00742L10.1899 12.0642L7.49996 10.4358Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStarIcon);
export default __webpack_public_path__ + "static/media/half-star-icon.84afc14ee2c5c950ec70756a171cab41.svg";
export { ForwardRef as ReactComponent };